//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
import "../no/Dimensions.js";
let d=[[[0,"DimensionDecimalPlaces",1,0],[0,"ToleranceType",1,0],[0,"ZeroToleranceDisplayStyle",1,0]],[[[],"Dispose",{},0,0],[[],"GetUpperToleranceDegrees",{R_:{upper_tolerance_degrees:''}},0,0],[["upper_tolerance_degrees"],"SetUpperToleranceDegrees",{},1,0],[[],"GetLowerToleranceDegrees",{R_:{lower_tolerance_degrees:''}},0,0],[["lower_tolerance_degrees"],"SetLowerToleranceDegrees",{},1,0]],[]];
SPLM.Annotations.AngularTolerance = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.AngularTolerance";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;